import { render, staticRenderFns } from "./OrganismFeedSectionInfo.vue?vue&type=template&id=794f7fe8&"
import script from "./OrganismFeedSectionInfo.vue?vue&type=script&lang=js&"
export * from "./OrganismFeedSectionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports